export function getProductionPollingLanes(showQcLane = false) {
  return showQcLane
    ? ["Scheduled", "In_Production", "QC", "On_Hold", "Completed"]
    : ["Scheduled", "In_Production", "On_Hold", "Completed"];
}

export function createProductionPollingController({
  poll,
  canRun = () => true,
  isHidden = () => false,
  intervalMs = 30000,
  retryBaseMs = 5000,
  retryMaxMs = 60000,
  nowFn = () => Date.now(),
  setIntervalFn = window.setInterval,
  clearIntervalFn = window.clearInterval,
} = {}) {
  let timer = null;
  let inFlight = false;
  let failureCount = 0;
  let retryAfter = 0;

  const run = async () => {
    if (inFlight || !canRun() || isHidden() || nowFn() < retryAfter) return false;
    inFlight = true;
    try {
      const result = await poll?.();
      if (result === false || result?.ok === false) throw new Error('Production polling cycle failed');
      failureCount = 0;
      retryAfter = 0;
      return true;
    } catch (error) {
      failureCount += 1;
      const delay = Math.min(
        Number(retryMaxMs) || 60000,
        (Number(retryBaseMs) || 5000) * (2 ** Math.max(0, failureCount - 1))
      );
      retryAfter = nowFn() + delay;
      return false;
    } finally {
      inFlight = false;
    }
  };

  return {
    run,
    start() {
      if (timer == null) timer = setIntervalFn(run, intervalMs);
      return timer;
    },
    stop() {
      if (timer != null) {
        clearIntervalFn(timer);
        timer = null;
      }
    },
  };
}
